import { AttachmentService } from 'src/app/services/attachment.service';
import { LatestCampaignModel } from './../../../models/Booking/LatestCampaignModel';
import { BookingService } from 'src/app/services/booking.service';
import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';


@Component({
  selector: 'top-deals',
  templateUrl: './top-deals.component.html',
  styleUrls: ['./top-deals.component.css']
})
export class TopDealsComponent implements OnInit {

  num:number = 5;

  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayHoverPause: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    navSpeed: 1000,
    navText: ['Previous', 'Next'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: false,
  }
  latestCampign: LatestCampaignModel[];

  constructor(private bookingService: BookingService, private attachmnetService: AttachmentService) { }

  ngOnInit(): void {
    this.bookingService.getLatestCampaigns().subscribe(res => {

      this.latestCampign = res;
    })
  }

  openCampaignLink(link: string) {

    if (link != null) {
      if (link.includes("https://") || link.includes("http://")) {
        window.open(link, '_blank');
      }
      else {
        link = "https://" + link;
        window.open(link, '_blank');
      }
    }


  }

  get AttachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get AttachmentTypeEnum() {
    return AttachmentTypeEnum;
  }

}
